<template>
  <div v-if="showCookieNotification" class="cookie-notification">
    <div class="cookie-content">
      <p>
        Наш сайт использует cookies для статистического анализа и улучшения
        работы веб-сайта. Запретить обработку cookies можно в настройках вашего
        браузера. Продолжая использовать сайт, вы даете <nuxt-link to="/agreement">согласие</nuxt-link> на
        использование файлов cookies.
        <nuxt-link to="/policy">Политика в отношении обработки персональных данных.</nuxt-link>
      </p>
      <div class="cookie-button">
        <el-button type="primary" @click="acceptCookies">Ок, понятно</el-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const { isMobile, isDesktop } = useDevice();

// Проверяем, показывать ли уведомление
const showCookieNotification = ref(false);

onMounted(() => {
  // Проверяем, было ли уведомление уже принято
  const cookieAccepted = localStorage.getItem("cookieAccepted");
  if (!cookieAccepted) {
    showCookieNotification.value = true;
  }
});

// Функция принятия cookies
const acceptCookies = () => {
  localStorage.setItem("cookieAccepted", "true");
  showCookieNotification.value = false;
};
</script>

<style scoped>
.cookie-notification {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  z-index: 1000;
}

.cookie-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: color-mix(in srgb, var(--el-bg-color) 90%, transparent);
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
}

/* Стили для мобильных устройств */
@media (max-width: 768px) {
  .cookie-content {
    margin: 0 20px; /* Отступы по краям */
  }
}

/* Стили для десктопа */
@media (min-width: 769px) {
  .cookie-content {
    width: 66.67%; /* 2/3 ширины экрана */
    min-width: 500px;
    max-width: 1000px;
  }
}

p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  flex-grow: 1; /* Текст занимает доступное пространство */
}

.cookie-button {
  margin-left: 20px;
  flex-shrink: 0; /* Кнопка не сжимается */
}
</style>
